/*
Copyright 2005 - 2021 Advantage Solutions, s. r. o.

This file is part of ORIGAM (http://www.origam.org).

ORIGAM is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

ORIGAM is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with ORIGAM. If not, see <http://www.gnu.org/licenses/>.
*/

import { handleError } from "model/actions/handleError";
import { getChatrooms } from "model/selectors/Chatrooms/getChatrooms";
import { getSearcher } from "model/selectors/getSearcher";

export function onRefreshChatrooms(ctx: any) {
  return function*onRefreshChatrooms() {
    try {
      const chatRooms = getChatrooms(ctx);
      yield*chatRooms.getChatroomsList();
      getSearcher(ctx).indexChats(chatRooms.items);
    } catch (e) {
      yield*handleError(ctx)(e);
      //console.log("Error during getChatroomsList call ignored.");
      throw e;
    }
    ;
  }
}
